"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberOrderApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class MemberOrderApi extends runtime.BaseAPI {
    /**
     * 會員取消訂單  T（待付款）→ 直接取消，不退款  A1（已送出）/ A2（處理中）→ 取消並呼叫藍新退款 API
     */
    memberOrderCancelOrderPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/CancelOrder`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.MemberCancelOrderRequestToJSON)(requestParameters['memberCancelOrderRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 會員取消訂單  T（待付款）→ 直接取消，不退款  A1（已送出）/ A2（處理中）→ 取消並呼叫藍新退款 API
     */
    memberOrderCancelOrderPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderCancelOrderPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 下載發票檔案（前台會員用）
     */
    memberOrderDownloadInvoiceGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orderNo'] != null) {
                queryParameters['orderNo'] = requestParameters['orderNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/DownloadInvoice`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * 下載發票檔案（前台會員用）
     */
    memberOrderDownloadInvoiceGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderDownloadInvoiceGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    memberOrderGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    memberOrderGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.memberOrderGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得會員訂單列表 (每筆只顯示一個商品)
     */
    memberOrderGetMemberOrdersGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['memberNo'] != null) {
                queryParameters['memberNo'] = requestParameters['memberNo'];
            }
            if (requestParameters['status'] != null) {
                queryParameters['status'] = requestParameters['status'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/GetMemberOrders`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得會員訂單列表 (每筆只顯示一個商品)
     */
    memberOrderGetMemberOrdersGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderGetMemberOrdersGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得訂單詳細資料 (含所有商品)
     */
    memberOrderGetOrderDetailGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orderNo'] != null) {
                queryParameters['orderNo'] = requestParameters['orderNo'];
            }
            if (requestParameters['orderId'] != null) {
                queryParameters['orderId'] = requestParameters['orderId'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/GetOrderDetail`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得訂單詳細資料 (含所有商品)
     */
    memberOrderGetOrderDetailGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderGetOrderDetailGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得訂單狀態歷史紀錄（從 InquiryOrderFormLog）
     */
    memberOrderGetOrderStatusHistoryGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orderNo'] != null) {
                queryParameters['orderNo'] = requestParameters['orderNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/GetOrderStatusHistory`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得訂單狀態歷史紀錄（從 InquiryOrderFormLog）
     */
    memberOrderGetOrderStatusHistoryGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderGetOrderStatusHistoryGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得訂單狀態清單（從 CodeSettings 動態讀取）
     */
    memberOrderGetOrderStatusesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/GetOrderStatuses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得訂單狀態清單（從 CodeSettings 動態讀取）
     */
    memberOrderGetOrderStatusesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.memberOrderGetOrderStatusesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 查詢訂單退款狀態
     */
    memberOrderGetRefundStatusGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orderNo'] != null) {
                queryParameters['orderNo'] = requestParameters['orderNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/GetRefundStatus`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 查詢訂單退款狀態
     */
    memberOrderGetRefundStatusGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderGetRefundStatusGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 檢查訂單是否有發票（前台會員用）
     */
    memberOrderHasInvoiceGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['orderNo'] != null) {
                queryParameters['orderNo'] = requestParameters['orderNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/MemberOrder/HasInvoice`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 檢查訂單是否有發票（前台會員用）
     */
    memberOrderHasInvoiceGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.memberOrderHasInvoiceGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.MemberOrderApi = MemberOrderApi;
